module.exports = __webpack_public_path__ + "static/media/cover-pic.4f82bc73.png";